import React, { useEffect, useState } from 'react'
import iconUser from 'assets/svg/icon-green-user.svg'
import jwtDecode from 'jwt-decode'
import { TokenJwt } from 'models/types'
import { NAVBAR } from 'store/modules/navbar/types'
import { ApplicationState } from 'store'
import { useSelector } from 'react-redux'
import * as navbarActions from 'store/modules/navbar/actions'
import useRedux from 'hooks/useRedux'
import { APICore } from 'helpers/api/apiCore'
import { useNavigate } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'
import * as loginActions from 'store/modules/login/actions'
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap'
import { CustomButton } from 'styles/global'
import { scrollWithOffset } from 'util/scrollWithOffset'
import ModalTrocarSenha from 'components/modalSenha'

function Navbar() {
  const { nomeUsuario } = useSelector<ApplicationState, NAVBAR>(
    (state) => state.navbar
  )
  const [produtosDropdownOpen, setProdutosDropdownOpen] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const AUTH_SESSION_KEY = 'TOKEN_KEY'

  const api = new APICore()

  const { dispatch } = useRedux()

  useEffect(() => {
    const token = sessionStorage.getItem(AUTH_SESSION_KEY)
    const tokenDecode: TokenJwt | null = token ? jwtDecode(token || '') : null
    if (tokenDecode && tokenDecode.name) {
      const nomeFormated = tokenDecode.name.split(' ')
      dispatch(
        navbarActions.setNomeUsuario(
          `${nomeFormated?.[0] || ''} ${nomeFormated?.[1] || ''}`
        )
      )
    }
  }, [dispatch])

  function logout() {
    dispatch(loginActions.logout())
  }
  function toggleModal() {
    setIsModalOpen(!isModalOpen)
  }
  const navigate = useNavigate()

  return (
    <header>
      <nav className="navbar navbar-expand-xl navbar-light">
        <div className="container d-flex flex-column flex-xl-row align-items-center justify-content-between w-100">
          <div className="d-flex justify-content-between w-xl-100">
            <a className="navbar-brand" href="/">
              <img
                src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/logo_1.png"
                height={30}
              />
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbar"
              aria-controls="navbar"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>
          <div
            className="collapse navbar-collapse justify-content-center w-100"
            id="navbar"
          >
            <ul className="navbar-nav d-flex column-gap-20">
              <li className="nav-item">
                <Dropdown
                  isOpen={produtosDropdownOpen}
                  toggle={() => setProdutosDropdownOpen(!produtosDropdownOpen)}
                  onMouseEnter={() => setProdutosDropdownOpen(true)}
                  onMouseLeave={() =>
                    setTimeout(() => setProdutosDropdownOpen(false), 5000)
                  }
                  className="dropdown-custom"
                >
                  <DropdownToggle
                    className="nav-link dropdown-toggle-custom"
                    tag="a"
                    caret={false}
                    onClick={(e) => {
                      e.preventDefault()
                      setProdutosDropdownOpen(!produtosDropdownOpen)
                    }}
                  >
                    Produtos
                    <span
                      className={`arrow ${
                        produtosDropdownOpen ? 'up' : 'down'
                      }`}
                    ></span>
                  </DropdownToggle>
                  <DropdownMenu
                    className="dropdown-menu-custom"
                    onMouseEnter={() => setProdutosDropdownOpen(true)}
                    onMouseLeave={() =>
                      setTimeout(() => setProdutosDropdownOpen(false), 300)
                    }
                  >
                    <div className="dropdown-inner-container">
                      <a
                        className="dropdown-link-item"
                        href="/produtos/credito-consignado"
                        onClick={() => setProdutosDropdownOpen(false)}
                      >
                        <DropdownItem className="dropdown-item-custom">
                          <span className="bullet"></span>
                          Crédito consignado
                        </DropdownItem>
                      </a>

                      <a
                        className="dropdown-link-item"
                        href="/produtos/cartao-consignado"
                        onClick={() => setProdutosDropdownOpen(false)}
                      >
                        <DropdownItem className="dropdown-item-custom">
                          <span className="bullet"></span>
                          Cartão consignado
                        </DropdownItem>
                      </a>

                      <a
                        className="dropdown-link-item"
                        href="/produtos/FGTS"
                        onClick={() => setProdutosDropdownOpen(false)}
                      >
                        <DropdownItem className="dropdown-item-custom">
                          <span className="bullet"></span>
                          Antecipação saque aniversário FGTS
                        </DropdownItem>
                      </a>

                      <a
                        className="dropdown-link-item"
                        href="/produtos/credito-pessoal"
                        onClick={() => setProdutosDropdownOpen(false)}
                      >
                        <DropdownItem className="dropdown-item-custom">
                          <span className="bullet"></span>
                          Crédito pessoal
                        </DropdownItem>
                      </a>
                    </div>
                  </DropdownMenu>
                </Dropdown>
              </li>
              <li className="nav-item">
                <HashLink
                  to="/sobre"
                  smooth
                  scroll={(el) => {
                    scrollWithOffset(el, 150)
                  }}
                  className="nav-link"
                >
                  Sobre
                </HashLink>
              </li>
              <li className="nav-item">
                <a
                  href="https://www.riberseguros.com.br"
                  target="_blank"
                  rel="noreferrer"
                  className="nav-link"
                >
                  Seguros
                </a>
              </li>
              <li className="nav-item">
                <HashLink
                  to="/"
                  smooth
                  scroll={(el) => {
                    scrollWithOffset(el, 150)
                  }}
                  className="nav-link"
                >
                  Blog
                </HashLink>
              </li>
              <li className="nav-item">
                <HashLink
                  to="/seja-parceiro"
                  smooth
                  scroll={(el) => {
                    scrollWithOffset(el, 150)
                  }}
                  className="nav-link"
                >
                  Seja Parceiro
                </HashLink>
              </li>
              <li className="nav-item">
                <HashLink
                  to="/trabalhe-conosco"
                  smooth
                  scroll={(el) => {
                    scrollWithOffset(el, 150)
                  }}
                  className="nav-link"
                >
                  Trabalhe Conosco
                </HashLink>
              </li>
            </ul>
          </div>
          <div
            className="collapse navbar-collapse justify-content-end align-items-center"
            id="navbar"
          >
            {api.isAuthenticated() ? (
              <div className="dropdown show">
                <a
                  className="btn d-flex align-items-center gap-2 dropdown-toggle"
                  href="#"
                  role="button"
                  id="dropdown"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <img src={iconUser} alt="Icone de usuário" width={33} />
                  {nomeUsuario}
                </a>
                <div
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuLink"
                >
                  <HashLink
                    className="dropdown-item"
                    to="/simulacao"
                    smooth
                    scroll={(el) => {
                      scrollWithOffset(el, 150)
                    }}
                  >
                    Voltar para Simulação
                  </HashLink>

                  <div>
                    <ul className="navbar-nav d-flex column-gap-15">
                      <li className="nav-item">
                        <span
                          className="dropdown-item"
                          onClick={toggleModal}
                          style={{ cursor: 'pointer' }}
                        >
                          Alterar senha
                        </span>
                      </li>
                    </ul>

                    {isModalOpen && (
                      <ModalTrocarSenha
                        isOpen={isModalOpen}
                        toggle={toggleModal}
                      />
                    )}
                  </div>

                  <a
                    className="dropdown-item"
                    onClick={() => {
                      logout()
                    }}
                  >
                    Sair
                  </a>
                </div>
              </div>
            ) : (
              <CustomButton
                background="var(--verde-riber)"
                onClick={() => {
                  navigate('/login')
                }}
                maxWidth="100px"
              >
                ENTRAR
              </CustomButton>
            )}
          </div>
        </div>
      </nav>
    </header>
  )
}

export default Navbar
